module.exports = __webpack_public_path__ + "2a0190823b4ebee10be44e89a295c132.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BI.svg
// module id = PPld
// module chunks = 0